import { useState, useRef } from 'react';
import '../../styles/dashboard.css';
import Login from './Login';
import Sidebar from './Sidebar';
import Overview from './pages/Overview';
import Profile from './pages/Profile';
import Clients from './pages/Clients';
import Invoices from './pages/Invoices';
import Projects from './pages/Projects';
import WebDev from './pages/WebDev';
import AIServices from './pages/AIServices';
import Research from './pages/Research';
import Contracts from './pages/Contracts';
import Settings from './pages/Settings';
import Messages from './pages/Messages';

const pageTitles = {
  dash: 'Overview', profile: 'My Profile', clients: 'Clients',
  invoice: 'Invoices', projects: 'Projects', webdev: 'Website Development',
  ai: 'AI & ML Solutions', research: 'Research & Technical Services',
  contracts: 'Contracts & Documents', settings: 'Settings', messages: 'Messages',
};

const pages = {
  dash: Overview, profile: Profile, clients: Clients,
  invoice: Invoices, projects: Projects, webdev: WebDev,
  ai: AIServices, research: Research, contracts: Contracts, settings: Settings, messages: Messages,
};

export default function Dashboard() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [page, setPage] = useState('dash');
  const [profilePic, setProfilePic] = useState(null);
  const topbarFileRef = useRef(null);

  if (!loggedIn) return <Login onLogin={() => setLoggedIn(true)} />;

  const PageComponent = pages[page] || Overview;

  return (
    <div className="dash-shell">
      <Sidebar page={page} setPage={setPage} onLogout={() => { if (window.confirm('Log out?')) setLoggedIn(false); }} />
      <div className="dash-main">
        <div className="dash-topbar">
          <div className="dash-topbar-title">{pageTitles[page]}</div>
          <div className="dash-topbar-right">
            <select className="d-finput" style={{ width: 140, fontSize: 12, padding: '6px 10px' }}>
              <option>April 2026</option>
              <option>March 2026</option>
              <option>Q1 2026</option>
              <option>Full Year 2026</option>
            </select>
            <button className="d-btn" onClick={() => {
              const csv = `Invoice,Client,Amount,Status\nINV-040,Aryan Consultants,45000,Paid\nINV-035,DataMinds AI Lab,120000,Pending`;
              const blob = new Blob([csv], { type: 'text/csv' });
              const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = 'LathiNyx_export.csv'; a.click();
            }}>↑ Export</button>
            <button className="d-btn d-btn-primary" onClick={() => setPage('contracts')}>+ New Document</button>
            <div className="d-topbar-user" onClick={() => setPage('profile')}>
              <div className="d-tu-av">
                {profilePic ? <img src={profilePic} alt="Profile" /> : 'AR'}
              </div>
              <span style={{ fontSize: 12, fontWeight: 600, color: '#111827' }}>Aryan</span>
            </div>
          </div>
        </div>
        <div className="dash-content">
          <PageComponent setPage={setPage} profilePic={profilePic} setProfilePic={setProfilePic} />
        </div>
      </div>
    </div>
  );
}
